import React from "react";
import { Link } from "react-router-dom";
import errorPic from "../../../assets/icons/404.jpg";

const Error = () => {
  const accessToken = localStorage.getItem("accessToken");
  const businessId = localStorage.getItem("businessId");

  const hasCredentials =
    (accessToken ?? "").trim() !== "" && (businessId ?? "").trim() !== "";
  return (
    <div className="opacity-100 h-screen text-white text-xl m-0 items-center flex justify-center bg-primaryPurple">
      <p className="text-center">
        <span>
          <img src={errorPic} alt="background" className="h-60 w-full " />
        </span>
        <br />
        The page you are looking for doesn't exist!
        <br />
        <span>
          <Link
            className="text-white"
            to={hasCredentials ? "/main/home" : "/login"}
          >
            {hasCredentials ? "Go Home" : "Go to login"}
          </Link>
        </span>
      </p>
    </div>
  );
};

export default Error;
